import { SvgIconModule } from '@toro/common/shared/components';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogDepositModule } from '../../dialog-deposit/dialog-deposit.module';
import { ActiveAccountTransferComponent } from './active-account-transfer.component';

@NgModule({
  declarations: [
    ActiveAccountTransferComponent,
  ],
  imports: [
    CommonModule,
    SvgIconModule,
    DialogDepositModule,
  ],
  exports: [ActiveAccountTransferComponent],
})
export class ActiveAccountTransferModule { }
